import { render, staticRenderFns } from "./postIdMix.vue?vue&type=template&id=2954b2d4"
import script from "./postIdMix.vue?vue&type=script&lang=js"
export * from "./postIdMix.vue?vue&type=script&lang=js"
import style0 from "./postIdMix.vue?vue&type=style&index=0&id=2954b2d4&prod&lang=scss&scope=true"
import style1 from "./postIdMix.vue?vue&type=style&index=1&id=2954b2d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports